"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.jane.description': 'Young, warm, smooth and friendly woman.',
};
